/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Proyek_TInputs */

const en_tut_proyek_t = /** @type {(inputs: Tut_Proyek_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projects, boards, and saved views`)
};

const id_tut_proyek_t = /** @type {(inputs: Tut_Proyek_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyek, papan, dan tampilan tersimpan`)
};

/**
* | output |
* | --- |
* | "Projects, boards, and saved views" |
*
* @param {Tut_Proyek_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_proyek_t = /** @type {((inputs?: Tut_Proyek_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Proyek_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_proyek_t(inputs)
	return en_tut_proyek_t(inputs)
});